export default __webpack_public_path__ + "static/media/Download_1-24.ff386a1e.svg";